<template>
  <div>
    <Button
      class="btn-color10"
      @click="requestURL"
      :loading="loader"
    >
      {{ buttonText }}
    </Button>
  </div>
</template>

<script>

import TikTokIntegrationService from '@/modules/integrations/services/tiktok-integration-service'

import Button from '@/components/common/Button/Button'

export default {
  name: 'TikTokIntegrationButton',
  props: ['redirectUri', 'text'],
  components: {
    Button
  },
  data () {
    return {
      loader: false
    }
  },
  computed: {
    /**
     * Button text
    */
    buttonText () {
      return this.text || 'Integrar com TikTok'
    }
  },
  methods: {
    async requestURL () {
      this.loader = true
      try {
        const data = await TikTokIntegrationService.getOAuthURL({
          redirect_uri: this.redirectUri
        })
        window.location.href = data.url
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  }
}
</script>
